import React, { useEffect, useState } from 'react';
import './NotificationBox.css';

interface NotificationBoxProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

const NotificationBox: React.FC<NotificationBoxProps> = ({ message, type, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Wait for fade out animation
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getBorderColor = () => {
    return type === 'success' ? 'border-green-500' : 'border-yellow-500';
  };

  const getTextColor = () => {
    return type === 'success' ? 'text-green-400' : 'text-yellow-400';
  };

  return (
    <div className={`fixed top-4 right-4 z-[100] transform transition-all duration-300 ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}>
      <div className={`relative bg-[#0d1117]/95 border ${getBorderColor()} rounded-lg p-4 shadow-lg min-w-[300px]`}>
        {/* Animated border */}
        <div className={`absolute inset-0 rounded-lg ${getBorderColor()} border-2 animate-border-spin`} />
        
        {/* Content */}
        <div className="relative z-10">
          <p className={`${getTextColor()} text-sm font-medium`}>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default NotificationBox; 